import { useState } from 'react'

import Button from '@atoms/Button'
import RequestForm from '@src/components/RequestForm'

import * as style from './style.module.sass'

type RequestProps = {
  isWhite?: boolean
}

const Request = ({ isWhite }: RequestProps) => {
  const [shown, setShown] = useState(false)

  const handleClick = () => {
    setShown(true)
  }

  return (
    <>
      <Button
        onClick={handleClick}
        design={isWhite ? 'white' : 'black'}
        size="medium"
      >
        <div className={style.icon}>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path
              d="M8.5 20.7422C8.29688 20.7422 8.13542 20.6719 8.01562 20.5312C7.90104 20.3958 7.84375 20.2109 7.84375 19.9766V17.8672H7.33594C6.63281 17.8672 6.03385 17.737 5.53906 17.4766C5.04427 17.2161 4.66667 16.8385 4.40625 16.3438C4.15104 15.849 4.02344 15.2526 4.02344 14.5547V8.27344C4.02344 7.57031 4.15104 6.97396 4.40625 6.48438C4.66667 5.98958 5.04427 5.61198 5.53906 5.35156C6.03385 5.08594 6.63281 4.95312 7.33594 4.95312H17.6641C18.3672 4.95312 18.9661 5.08594 19.4609 5.35156C19.9557 5.61198 20.3307 5.98958 20.5859 6.48438C20.8464 6.97917 20.9766 7.57552 20.9766 8.27344V14.5547C20.9766 15.2526 20.8464 15.849 20.5859 16.3438C20.3307 16.8333 19.9557 17.2109 19.4609 17.4766C18.9661 17.737 18.3672 17.8672 17.6641 17.8672H12.1016L9.35938 20.2812C9.1875 20.4323 9.03906 20.5469 8.91406 20.625C8.78906 20.7031 8.65104 20.7422 8.5 20.7422ZM8.74219 19.6562L11.3125 17.2188C11.4427 17.0938 11.5625 17.013 11.6719 16.9766C11.7812 16.9349 11.9245 16.9141 12.1016 16.9141H17.6562C18.4219 16.9141 19.0052 16.7083 19.4062 16.2969C19.8125 15.8854 20.0156 15.3021 20.0156 14.5469V8.27344C20.0156 7.52344 19.8125 6.94531 19.4062 6.53906C19.0052 6.1276 18.4219 5.92188 17.6562 5.92188H7.34375C6.57292 5.92188 5.98698 6.1276 5.58594 6.53906C5.1849 6.94531 4.98438 7.52344 4.98438 8.27344V14.5469C4.98438 15.3021 5.1849 15.8854 5.58594 16.2969C5.98698 16.7083 6.57292 16.9141 7.34375 16.9141H8.28906C8.45052 16.9141 8.5651 16.9479 8.63281 17.0156C8.70573 17.0833 8.74219 17.1979 8.74219 17.3594V19.6562ZM8.95312 11.4141C8.95312 11.263 9 11.1406 9.09375 11.0469C9.1875 10.9531 9.3125 10.9062 9.46875 10.9062H12V8.36719C12 8.21615 12.0469 8.09375 12.1406 8C12.2344 7.90104 12.3516 7.85156 12.4922 7.85156C12.6432 7.85156 12.7656 7.89844 12.8594 7.99219C12.9531 8.08594 13 8.21094 13 8.36719V10.9062H15.5469C15.6927 10.9062 15.8125 10.9531 15.9062 11.0469C16 11.1406 16.0469 11.263 16.0469 11.4141C16.0469 11.5547 16 11.6719 15.9062 11.7656C15.8125 11.8542 15.6927 11.8984 15.5469 11.8984H13V14.4453C13 14.5964 12.9531 14.7188 12.8594 14.8125C12.7656 14.9062 12.6432 14.9531 12.4922 14.9531C12.3516 14.9531 12.2344 14.9062 12.1406 14.8125C12.0469 14.7135 12 14.5911 12 14.4453V11.8984H9.46875C9.31771 11.8984 9.19271 11.8542 9.09375 11.7656C9 11.6719 8.95312 11.5547 8.95312 11.4141Z"
              fill="currentColor"
            />
          </svg>
        </div>
        取材&amp;記事リクエストはこちら
      </Button>
      {shown && (
        <RequestForm
          close={() => {
            setShown(false)
          }}
        />
      )}
    </>
  )
}

export default Request
